{
  "more": "Mais itens"
}
